module.exports = __webpack_public_path__ + "7252c1ed0c44e9ea051a940a63a68248.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/osm-buildings.png
// module id = 1536
// module chunks = 1